import { UIMode } from "../../../Redux/uiSlice"
import { ModeSwitcher } from "../../ModeSwitcher"

export const Assets = () => {
  return (

    <div className="bg-antiqueWhite flex flex-col justify-center items-center p-3 sm:p-4 relative h-dvh box-border">
      <div className="flex flex-col items-center justify-center h-full">
        <img className="w-[400px] max-w-[400px] mb-4" src='./wowboi-logo.png' />
        <img className="w-[240px] max-w-[240px]" src='./fav.png' />
      </div>
    </div>

  )
}